import { LockOpen, Visibility, VisibilityOff } from "@mui/icons-material";
import {
  Avatar,
  DialogContent,
  Divider,
  Grid,
  IconButton,
  Switch,
  Tab,
  Tabs,
  Typography,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { Box, styled, useMediaQuery, useTheme } from "@mui/system";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import axios from "axios";
import imageCompression from "browser-image-compression";
import { Buffer } from "buffer";
import dayjs from "dayjs";
import { groupBy } from "lodash";
import React, { useEffect, useRef, useState } from "react";
import { Helmet } from "react-helmet";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { RootState } from "../../Store";
import { strings } from "../../Store/Localization";
import CustomButton from "../../UiComponent/CustomButton";
import CustomDatePicker from "../../UiComponent/CustomDatePicker";
import DraggableDialog from "../../UiComponent/DraggableDialog";
import Loader from "../../UiComponent/Loader";
import NewHeader from "../../UiComponent/NewHeader";
import InputField from "../../UiComponent/TextFeild";
import Toast from "../../UiComponent/Toast/Toast";
import {
  IdenfyArchivedIcon,
  IdenfyDeletedIcon,
  IdenfyDeniedIcon,
  IdenfyExpiredIcon,
  IdenfyReviewingIcon,
  IdenfySuspectedIcon,
  SmallStarIcon,
  SmallStarIconGray,
  VerifyIcon,
} from "../../assets/images/FrankIcons";

import moment from "moment";
import { Rating } from "react-simple-star-rating";
import BankUpdateForm from "../../UiComponent/BankUpdateForm";
import { BASE_URL } from "../../services/HttpProvider";
import apiServices from "../../services/RequestHandler";
import {
  clearAllDataFromLocalStorage,
  getDataFromLocalStorage,
  saveDataToLocalStorage,
} from "../../utils/LocalStore.util";
import {
  color_theme,
  defaultLabelColors,
  no_profile_image,
} from "../../utils/constants";
import { currencyFormat, getCardImage, toBase64, useResponsiveValue1024 } from "../../utils/helper";
import InjectedCheckoutForm from "../MarketPlace/Checkout/StripeCheckout";
import StripeCheckout from "../MyAnnounces/StripeCheckout";
import ProfileMobileView from "./ProfileMobileView";
import SwitchFeild from "../../UiComponent/SwitchField";
declare global {
  interface Window {
    idenfyWebSdk: any;
  }
}

const useStyles = makeStyles(() => ({
  scrollableArea: {
    height: "600px", // Give the area a height to enable scrolling
    width: "100%",
    overflowY: "auto", // Enable vertical scrolling
    padding: "10px",

    /* Custom scrollbar for WebKit browsers */
    "&::-webkit-scrollbar": {
      width: "12px", // Width of the scrollbar
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#ee6931", // Color of the scrollbar thumb
      borderRadius: "10px",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#f5f5f5", // Background of the scrollbar track
    },

    /* Custom scrollbar for Firefox */
    scrollbarWidth: "thin", // Thin scrollbar for Firefox
    scrollbarColor: "#ee6931 #f5f5f5", // Thumb and track colors for Firefox
  },
}));

export const CustomSwitch = styled(Switch)({
  "& .Mui-checked": {
    color: "#ee6931", // Active color
  },
  "& .Mui-checked + .MuiSwitch-track": {
    backgroundColor: "#ee6931", // Track color when checked
  },
});

export const CustomTabs = styled(Tabs)({
  "& .MuiTabs-flexContainer": {
    gap: 20,
  },
  "& .MuiTabs-indicator": {
    backgroundColor: "transparent", // Indicator color
  },
});



interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

export function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 1 }}>{children}</Box>}
    </div>
  );
}


function Profile(props: any) {
  const classes = useStyles();
  const selector = useSelector((state: RootState) => state);
  const theme = useTheme();
  const lg = useMediaQuery(theme.breakpoints.up("lg"));
  const xl = useMediaQuery(theme.breakpoints.up("xl"));
  const screen_1024 = useMediaQuery(theme.breakpoints.up(1025));
  const fileInputRef = useRef<HTMLInputElement | null>(null);
///
 const CustomTab = styled(Tab)({
  fontFamily:"montserrat-SemiBold",

  fontWeight: 600,
  fontSize: useResponsiveValue1024("16px","14px"),
  textTransform: "capitalize",
  minHeight: "36px !important",
  color: "#626175", // Inactive tab text color

  background: "white",
  "&.Mui-selected": {
    background: "#504AEA",
    color: "white",
  },
});
////
  const [state, setState] = React.useReducer(
    (state: any, newState: any) => ({ ...state, ...newState }),
    {
      viewPasswordOld: false,
      viewPasswordNew: false,
      viewPasswordConfirm: false,
      loading: true,
      loadingLoader: true,
      numbrOfjobResult: 5,
      numbrOfAnnouceResult: 5,
      accountDetails: null,
      isBankAvailable: false,
      earningLength: 6,
      user: getDataFromLocalStorage("user"),
      initilalTotalFeedBack: 6,
      pass_dialog: false,
    }
  );
  const stripePromise = loadStripe(
    "pk_live_51PHLwERrtK56w4VJcMQLW2zbn7LTZPNZnBLUmFdMIakX5v5HKsPRllmYUMmWJXvmPVJaptcEN8uxmQdzDNVJYFUC0050uiD5gE"
    // "pk_test_51PHLwERrtK56w4VJovEUBRsfDb0K90Mo3tt7QrypEedKpj9HuTszcu8bnI8SnXsmA7EWSwZ87LorkcfAHi7zXz4l00kogJUBL5"
  );
  // const [verticalTabValue, setVerticalTabValue] = React.useState(
  //   Number(getDataFromLocalStorage("tab_state")?.ver_tab ?? 0)
  // );
  const [idenfyToken, setIdenfyToken] = useState(null);
  const [value, setValue] = React.useState(
    Number(getDataFromLocalStorage("tab_state")?.hor_tab ?? 0)
  );

  const handleNotificationClick = () => {
    const userAgent = navigator.userAgent.toLowerCase();
    let guideUrl = "";

    if (userAgent.includes("chrome")) {
      guideUrl = "chrome://settings/content/notifications";
    } else if (userAgent.includes("firefox")) {
      guideUrl = "about:preferences#privacy";
    } else if (userAgent.includes("safari")) {
      alert(
        'To turn off notifications on Safari:\n\n1. Open Safari\n2. Go to Preferences > Websites > Notifications\n3. Find your website and set to "Deny"'
      );
      return;
    } else {
      alert("Please check your browser settings to disable notifications.");
      return;
    }
    window.open(guideUrl, "_blank");
  };

  const [selectedDate, setSelectedDate] = useState<dayjs.Dayjs | null>(null);
  // eslint-disable-next-line
  const [formattedDate, setFormattedDate] = useState<string>("");

  const navigate = useNavigate();
  const handleStartVerification = async () => {
    try {
      const user = getDataFromLocalStorage("user");

      // let clientId = "hTq22kmSqn0"; // DEVELOPMENT-KEYS
      // let secretKey = "WblCDVir4Aiy74k3LucS"; // DEVELOPMENT-KEYS

      const clientId = "hNxsS9O64Cg"; // PRODUCTION-KEYS
      const secretKey = "QaOBG6jLO4Idv3IF5DEF"; // PRODUCTION-KEYS

      let encodedAuth = new Buffer(clientId + ":" + secretKey).toString(
        "base64"
      );

      const response = await fetch(`https://ivs.idenfy.com/api/v2/token`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Basic " + encodedAuth,
        },
        body: JSON.stringify({
          clientId: `FRNK-${user?.id}`,
        }),
      });

      let result = await response.json();
      const token = result.authToken;

      // // Initialize and start iDenfy if token is available
      if (token) {
        // Check if the iDenfy SDK is loaded
        setIdenfyToken(token);
        setState({ openIdenfyDialog: true });
        
      } else {
        console.error("Failed to retrieve iDenfy token");
      }
    } catch (error) {
      // Provide more detailed error information
      console.error("Error during iDenfy verification:", error);
    }
  };
  const handleSubmit = (data: any) => {
    setState({ openForm: false });
  };
  const handleGetUserDetails = async (item: any) => {
    try {
      const resp = await apiServices.getFromApi(
        `c2c/get-user-details/${item}`,
        ""
      );

      let avg_rating_ = resp.data?.ratings2?.reduce((a: any, b: any) => {
        return a + b.rating;
      }, 0);
      let avg_rating = isNaN(avg_rating_ / resp?.data?.ratings2?.length)
        ? 0
        : avg_rating_ / resp?.data?.ratings2?.length;
      setState({
        allRatings: resp?.data,
        reviews: resp?.data?.ratings2,
        details: {
          ...resp.data,
          avg_rating,
        },
      });
    } catch (error) {}
  };
 
  const handleGetHisory = async () => {
    try {
      const resp = await apiServices.getFromApi("/c2c-orders/by-customer", "");
      let order_history = resp?.data?.sort((a: any, b: any) =>
        new Date(a.created_at).getTime() < new Date(b.created_at).getTime()
          ? 1
          : -1
      );
      let un_paid = [],
        paid = [];

      for (const i of order_history) {
        if (i.is_draft) {
          if (i.is_particular) {
            un_paid.push({ ...i, order_transaction_id: i.id });
          } else {
            un_paid.push(i);
          }
        } else {
          paid.push(i);
        }
      }
      let grouped = groupBy(un_paid, "order_transaction_id");

      let unPaid_orders = [];
      for (const key in grouped) {
        if (Object.prototype.hasOwnProperty.call(grouped, key)) {
          const item = grouped[key];
          unPaid_orders.push(item);
        }
      }
      setState({
        unPaid_orders,
        order_history: paid,
        refreshing: false,
        no_orders: order_history?.length > 0 ? true : false,
      });
    } catch (error) {
      setState({
        refreshing: false,
      });

      console.log(error);
    }
  };
  const handleConfirmPayment = async () => {
    try {
      setState({ loadingLoader: true });
      // eslint-disable-next-line
      const resp2 = await apiServices.postFromApi(
        state.stripe_form?.is_particular
          ? `c2c-orders/particular/submit-order`
          : "/c2c-orders/submit-order",
        state.stripe_form?.is_particular
          ? {
              order_id: Number(state.stripe_form?.tr_id),
            }
          : {
              order_transaction_id: Number(state.stripe_form?.tr_id),
              billing_address: null,
            },
        ""
      );
      handleGetHisory();
      setState({
        openFuturePayment: false,
        loadingLoader: false,
        loading: false,
        stripe_form: null,
      });
    } catch (error) {
      setState({
        loadingLoader: false,
      });
      console.log(error);
    }
  };
  
  
  const deleteCard = async (idd: any) => {
    try {
      let resp = await apiServices.getFromApi(
        `stripe/payment_methods/delete/${idd}`,
        ""
      );
      if (resp?.status === 200) {
        setState({
          card_id: null,
          openConfirmDialog: false,
        });
        Toast.showSuccess(resp?.message);
        getCardDetails();
      }
    } catch (error) {}
  };
  
  const handleDateChange = (newValue: dayjs.Dayjs | null) => {
    setSelectedDate(newValue);
    if (newValue) {
      const formatted = newValue.format("YYYY/MM/DD");
      setFormattedDate(formatted);
    }
  };
  useEffect(() => {
    handleGetProfileInfo();
    getCardDetails();

    // eslint-disable-next-line
  }, []);
  
  useEffect(() => {}, [selector.mainApp.lang]);
  const handleChangePassword = async () => {
    try {
      if (!state?.oldPassword) {
        Toast.Error(strings?.enter_o_password);
        return;
      }
      if (!state?.newPassword) {
        Toast.Error(strings?.enter_n_password);
        return;
      }
      if (!state?.confirmPassword) {
        Toast.Error("Veuillez saisir le mot de passe confirmé");
        return;
      }
      if (state?.newPassword !== state?.confirmPassword) {
        Toast.Error(strings?.passowrd_not_match);
        return;
      }

      let obj = {
        old_password: state?.oldPassword,
        new_password: state?.newPassword,
        password_confirm: state?.confirmPassword,
      };

      let resp = await apiServices.postFromApi(
        "c2c/change-my-password",
        obj,
        ""
      );
      if (resp?.status === 200 || resp?.status === 201) {
        Toast.showSuccess(strings?.password_changed_seccess);
        setState({
          openForgetPasswordDialog: false,
          oldPassword: "",
          newPassword: "",
          confirmPassword: "",
        });
        clearAllDataFromLocalStorage();
        navigate("/login");
      } else {
        Toast.Error(
          resp.error?.error ??
            resp.error?.message ??
            resp?.message ??
            resp?.error?.error ??
            "Internal Server Error"
        );
      }
    } catch (error) {}
  };

  

  const onInputChangeTwo = (e: any) => {
    try {
      const { value, name } = e.target;

      if (value[0] === " ") {
        return;
      }

      setState({
        [name]: value,
      });
    } catch (error) {}
  };
  const getCardDetails = async () => {
    try {
      let resp_card = await apiServices.getFromApi(
        "Stripe/payment_methods",
        ""
      );
      if (resp_card?.status === 200) {
        setState({ card_detail: resp_card?.paymentMethods });
      }
    } catch (error) {}
  };
  const handleGetProfileInfo = async () => {
    try {
      let resp = await apiServices.getFromApi("c2c/me", "");

      saveDataToLocalStorage("user", resp?.data);
      setState({
        user_name: resp?.data?.user_name,
        userDetails: resp?.data,
        title: resp?.data?.title,
        first_name: resp?.data?.first_name,
        surname: resp?.data?.surname,
        phone_code: resp?.data?.phone_code,
        phone: resp?.data?.phone,
        email: resp?.data?.email,
        date_of_birth: resp?.data?.date_of_birth,
        profile_pic: resp?.data?.profile_pic,
        loadingLoader: false,
      });

      setSelectedDate(dayjs(resp?.data?.date_of_birth));
      handleGetUserDetails(resp?.data?.id);
    } catch (error) {
      console.log(error);
    }
  };
  
  const handleUpdateProfilePic = async (profile_link: string) => {
    try {
      setState({
        loadingLoader: true,
      });
      let obj = {
        profile_pic: profile_link,
      };

      let resp = await apiServices.patchFromApi("c2c/update-me", obj, "");
      if (resp?.status === 200 || resp.status === 201) {
        Toast.showSuccess("Profile Updated Succesfully!");
        handleGetProfileInfo();
        setState({
          loadingLoader: false,
        });
      }
      setState({
        loadingLoader: false,
      });
    } catch (error) {
      setState({
        loadingLoader: false,
      });
    }
  };
  
  

  const handleInitStripeSetupPayment = async () => {
    try {
      const resp = await apiServices.postFromApi(
        "stripe/payment-sheet",
        {},
        ""
      );

      const { setupIntent, ephemeralKey, customer } = resp;
      setState({
        options: {
          setupIntent,
          ephemeralKey,
          customer,
        },
        openFuturePayment: true,
      });
      return {
        setupIntent,
        ephemeralKey,
        customer,
      };
    } catch (error) {
      console.log(error);
    }
  };
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
    const saved_tab = getDataFromLocalStorage("tab_state");
    saveDataToLocalStorage("tab_state", {
      hor_tab: newValue,
      ver_tab: saved_tab?.ver_tab,
    });
  };
 
  const handleCloseDialog = () => {
    try {
      setState({ openFuturePayment: false });
    } catch (error) {}
  };
  const handleLaunchCamera = async (e: any, stateName: string) => {
    try {
      setState((prevState: any) => ({ ...prevState, loading: true }));
      const imageFile = e.target.files[0];

      const options = {
        maxSizeMB: 1,
        maxWidthOrHeight: 1920,
        useWebWorker: true,
      };

      const compressedFile = await imageCompression(imageFile, options);

      let file = compressedFile || null;
      let uri = (await toBase64(file)) as any;

      if (!uri) {
        return;
      }

      const modifiedFile = new File(
        [file],
        `${stateName}-` + new Date().getTime(),
        { type: file.type }
      );
      let formData = new FormData();

      formData.append("files", modifiedFile);

      const resp = await axios({
        baseURL: BASE_URL,
        headers: {
          "Content-Type": "multipart/form-data", // this is important
        },
        method: "post",
        url: "upload/upload-multiple",
        data: formData,
      });

      setState({ profile_pic: resp?.data?.data[0]?.uri });

      setState((prevState: any) => ({
        ...prevState,
        [`${stateName}_obj`]: { modifiedFile, uri },
        [`show_${stateName}`]: true,
        loading: false,
      }));
      //

      handleUpdateProfilePic(resp?.data?.data[0]?.uri);
    } catch (error) {
      console.log(error);
      setState((prevState: any) => ({ ...prevState, loading: false }));
    }
  };
  const triggerFileInput = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const checkPasswrodValidate = async () => {
    try {
      const resp = await apiServices.postFromApi(
        "c2c/validate-password",
        { password: state?.oldPassword },
        ""
      );
      if (resp?.status === 200) {
        Toast.showSuccess(`${resp?.message}`);

        setState({ pass_dialog: true });
      } else {
        Toast.Error(`${resp?.error}`);
      }

    } catch (err) {
      console.log(err, "err");
    }
  };

  const { reviews } = state;

  const [startIndex, setStartIndex] = useState(0);
  const itemsPerPage = xl || lg ? 2 : 2;

  const handleNext = () => {
    if (startIndex + itemsPerPage < reviews?.length) {
      setStartIndex(startIndex + itemsPerPage);
    }
  };

  const handlePrev = () => {
    if (startIndex - itemsPerPage >= 0) {
      setStartIndex(startIndex - itemsPerPage);
    }
  };

  return (
    <>
      <Helmet>
        <title>Profil Utilisateur | Gérez Votre Compte sur Frank</title>
        <link
          rel="canonical"
          href="https://www.frank.fr/profile"
        />
        <link
          rel="icon"
          type="image/png"
          href="../../../public/frank_favicon.png"
        />
        <meta
          name="description"
          content="Gérez votre compte Frank, consultez vos annonces, vos messages et vos informations personnelles. Personnalisez votre expérience de livraison collaborative."
        />
      </Helmet>

      <div
        className="web-screen2"
      >
                <div style={{ background: defaultLabelColors.main_background_new, justifyItems: "center",display: "flex",
            justifyContent: "center" }}>
        
        <Loader loading={state?.loadingLoader} />
        

            <div
         style={{
           maxWidth: 1408,
           width: "100%",
          }}
        >
          <NewHeader />
        <div
          style={{
            paddingLeft: 16,
            paddingRight: 16,
            paddingTop: 140,
          }}
        >
          {screen_1024 ? (
            <Grid container spacing={0}>
              <Grid item xl={4} lg={4} md={4} xs={12}></Grid>
              <Grid item xl={8} lg={8} md={8} xs={12}>
                <Box>
                  <CustomTabs
                    value={value}
                    onChange={handleChange}
                    aria-label="basic tabs example"
                    style={{ gap: 10 }}
                  >
                    <CustomTab
                      label={strings.my_detail}
                      style={{ height: 36, width: 148, borderRadius: 100 }}
                    />

                    <CustomTab
                      label="Évaluations"
                      style={{ height: 36, width: 148, borderRadius: 100 }}
                    />
                    
                  </CustomTabs>
                </Box>
              </Grid>
            </Grid>
          ) : null}

          <Grid container spacing={2}>
            <Grid
              item
              xl={4}
              lg={4}
              md={screen_1024 ? 4: 12}
              sm={12}
              xs={12}
              sx={screen_1024?{
                position: "sticky",
                top: "170px", // Stick to top when scrolling
                alignSelf: "flex-start", // Important to prevent stretching
                height: "fit-content",   // Important to prevent it from growing
              }
              :{ display: "flex", justifyContent: "center", }
            }
            >
              <div
                style={{
                  background: "white",
                  borderRadius: 20,
                  padding: "20px 20px",
                  minWidth:screen_1024?"unset" :'358px',
                  display: "flex",
                  justifyContent: "center",
                  flexDirection:"column"
                }}
              >
                <div style={{ display: "flex", gap: 20,padding:20 }}>
                  <div id="side-img" style={{padding:"0px 10px"}}>
                    <div
                      style={{
                        position: "relative",
                        display: "flex",
                        border: `1px solid ${color_theme.black_10}`,
                        borderRadius: "100%",
                        height: 150,
                        width: 150,
                      }}
                    >
                    <img
  src={
    state?.profile_pic
      ? state?.profile_pic
      : state?.userDetails?.profile_pic ?? no_profile_image
  }
  alt="Profile"
  onError={(e) => {
    e.currentTarget.onerror = null; // Prevent infinite loop
    e.currentTarget.src = no_profile_image;
  }}
  style={{
    width: "150px",
    height: "150px",
    borderRadius: "100%",
    objectFit: "contain",
  }}
/>
                      <div
                        style={{
                          position: "absolute",
                          bottom: -10,
                          right: "10%",
                          left: "10%",
                          display: "flex",
                          gap: 5,
                          background: "#fff",
                          borderRadius: 20,
                          boxShadow: " 0px 3px 8.6px 0px #00000040",
                          padding: "5px 10px",
                          cursor: "pointer",
                        }}
                        onClick={triggerFileInput}
                        aria-label="upload picture"
                      >
                        <div className="display-flex">
                          <svg
                            width="25"
                            height="24"
                            viewBox="0 0 25 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M15 4H10L7.5 7H4.5C3.96957 7 3.46086 7.21071 3.08579 7.58579C2.71071 7.96086 2.5 8.46957 2.5 9V18C2.5 18.5304 2.71071 19.0391 3.08579 19.4142C3.46086 19.7893 3.96957 20 4.5 20H20.5C21.0304 20 21.5391 19.7893 21.9142 19.4142C22.2893 19.0391 22.5 18.5304 22.5 18V9C22.5 8.46957 22.2893 7.96086 21.9142 7.58579C21.5391 7.21071 21.0304 7 20.5 7H17.5L15 4Z"
                              stroke="black"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M12.5 16C14.1569 16 15.5 14.6569 15.5 13C15.5 11.3431 14.1569 10 12.5 10C10.8431 10 9.5 11.3431 9.5 13C9.5 14.6569 10.8431 16 12.5 16Z"
                              stroke="black"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </div>
                        <div className="display-flex">
                          <p
                            className="para-padd-marg"
                            style={{ fontSize: 16, fontWeight: 600 }}
                          >
                            Modifier
                          </p>
                        </div>
                      </div>

                      <input
                        type="file"
                        accept="image/*"
                        ref={fileInputRef}
                        onChange={(e) => handleLaunchCamera(e, "profile")}
                        style={{ display: "none" }}
                      />

                      {state?.userDetails?.idenfy_verification === true &&
                      state?.userDetails?.idenfy_verification_status ===
                        "APPROVED" ? (
                        <div
                          style={{
                            position: "absolute",
                            bottom: "15%",
                            right: 0,
                          }}
                        >
                          <VerifyIcon />
                        </div>
                      ) : null}
                    </div>
                    <div
                      className="display-flex"
                      style={{ paddingTop: 30, paddingBottom: 10 }}
                    >
                      <p
                        className="para-padd-marg"
                        style={{
                          fontSize: useResponsiveValue1024("28px", "22px"),
                          fontWeight: "bold",
                          fontFamily: "montserrat-Bold",
                          color: "#281208",
                        }}
                      >
                        {state?.userDetails?.first_name ?? "-"}
                      </p>
                    </div>
                  </div>
                  <div
                    id="side-prof"
                    style={{
                      width: "100%",
                      display: "flex",
                      flexDirection: "column",
                      gap: 10,
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                      }}
                      className="profile-side-text"
                    >
                      <p
                        style={{
                          padding: 0,
                          margin: 0,
                          fontSize: 22,
                          fontFamily: "montserrat-SemiBold",
                        }}
                      >
                        {state?.allRatings?.ratings2?.length
                          ? state?.allRatings?.ratings2?.length
                          : 0}
                      </p>{" "}
                      <p
                        style={{
                          padding: 0,
                          margin: 0,
                          fontSize: 14,
                          color: "#281208",
                          fontFamily: "montserrat-Regular",
                        }}
                      >
                        Avis
                      </p>
                    </div>
                    <Divider></Divider>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                      }}
                      className="profile-side-text"
                    >
                      <p
                        style={{
                          padding: 0,
                          margin: 0,
                          fontSize: 22,
                          fontFamily: "montserrat-SemiBold",
                        }}
                      >
                        {state?.userDetails?.rating> 0 ?currencyFormat(state?.userDetails?.rating?.toFixed(1)):"---"}
                        <span>
                          <svg
                            width="20"
                            height="19"
                            viewBox="0 0 20 19"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M9.60404 1.91371C9.64056 1.83993 9.69697 1.77782 9.76692 1.7344C9.83686 1.69098 9.91755 1.66797 9.99987 1.66797C10.0822 1.66797 10.1629 1.69098 10.2328 1.7344C10.3028 1.77782 10.3592 1.83993 10.3957 1.91371L12.3207 5.81288C12.4475 6.06952 12.6347 6.29155 12.8662 6.45992C13.0977 6.6283 13.3666 6.73797 13.6499 6.77955L17.9549 7.40955C18.0364 7.42137 18.1131 7.45577 18.1761 7.50888C18.2391 7.56199 18.2861 7.63167 18.3116 7.71005C18.337 7.78843 18.3401 7.87239 18.3204 7.95241C18.3006 8.03243 18.2589 8.10534 18.1999 8.16288L15.0865 11.1945C14.8812 11.3946 14.7276 11.6416 14.6389 11.9142C14.5502 12.1869 14.5291 12.477 14.5774 12.7595L15.3124 17.0429C15.3268 17.1244 15.318 17.2083 15.287 17.2851C15.2559 17.3619 15.204 17.4284 15.137 17.477C15.07 17.5257 14.9907 17.5545 14.9081 17.5603C14.8255 17.566 14.743 17.5485 14.6699 17.5095L10.8215 15.4862C10.568 15.3531 10.2859 15.2835 9.99946 15.2835C9.71306 15.2835 9.43094 15.3531 9.17737 15.4862L5.32987 17.5095C5.25681 17.5482 5.17437 17.5656 5.09191 17.5598C5.00946 17.5539 4.9303 17.525 4.86345 17.4764C4.7966 17.4278 4.74473 17.3614 4.71375 17.2847C4.68277 17.2081 4.67392 17.1243 4.68821 17.0429L5.42237 12.7604C5.47087 12.4777 5.44986 12.1874 5.36115 11.9146C5.27245 11.6418 5.11871 11.3947 4.91321 11.1945L1.79987 8.16371C1.74037 8.10624 1.6982 8.03321 1.67817 7.95294C1.65815 7.87267 1.66107 7.78839 1.6866 7.70971C1.71214 7.63102 1.75926 7.56108 1.8226 7.50787C1.88594 7.45465 1.96296 7.4203 2.04487 7.40871L6.34904 6.77955C6.63259 6.7383 6.90186 6.62876 7.13369 6.46037C7.36552 6.29198 7.55296 6.06977 7.67987 5.81288L9.60404 1.91371Z"
                              fill="black"
                              stroke="black"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </span>
                      </p>
                      <p
                        style={{
                          padding: 0,
                          margin: 0,
                          fontSize: 14,
                          color: "#281208",
                          fontFamily: "montserrat-Regular",
                        }}
                      >
                        note globale
                      </p>
                    </div>
                    <Divider></Divider>

                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                      }}
                      className="profile-side-text"
                    >
                      <p
                        style={{
                          padding: 0,
                          margin: 0,
                          fontSize: 22,
                          fontFamily: "montserrat-SemiBold",
                        }}
                      >
                        {state?.userDetails?.created_at
                          ? moment(state?.userDetails?.created_at).format(
                              "YYYY"
                            )
                          : ""}
                      </p>
                      <p
                        style={{
                          padding: 0,
                          margin: 0,
                          fontSize: 14,
                          color: "#281208",
                          fontFamily: "montserrat-Regular",
                        }}
                      >
                        {" "}
                        membre depuis{" "}
                      </p>
                    </div>
                  </div>
                </div>
                {state?.userDetails?.idenfy_verification !== true &&(<><Divider></Divider>
                  <div className="display-flex">
                  <p
                    style={{
                      color:
                        state?.userDetails?.idenfy_verification === true
                          ? "black"
                          : "#FF3B30",
                    }}
                  >
                    { "Profil non vérifié"}
                  </p>
                </div>
                </>)}
                
              </div>
            </Grid>
            {!screen_1024 ? (
              <Grid item sx={{marginTop:"14px"}}>
                <Box>
                  <CustomTabs
                    value={value}
                    onChange={handleChange}
                    aria-label="basic tabs example"
                    style={{ gap: 10 }}
                  >
                    <CustomTab
                      label={strings.my_detail}
                      style={{ height: 36, width: 58, borderRadius: 100 }}
                    />

                    <CustomTab
                      label="Évaluations"
                      style={{ height: 36, width: 116, borderRadius: 100 }}
                    />
                    
                  </CustomTabs>
                </Box>
              </Grid>
            ) : null}
            <Grid item xl={8} lg={8} md={ screen_1024 ? 8 : 12} sm={12} xs={12} key={"yessor"}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  background: "white",
                  borderRadius: 24,
                  padding: screen_1024?"10px 20px":"10px 2px",
                }}
              >
                <div
                  
                >
                  <CustomTabPanel value={value} index={0}>
                    <Grid
                      xs={12}
                      lg={12}
                      item
                      container
                      spacing={2}
                      key={"text-area"}
                    >
                      <Grid xs={12} md={12} item>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                          }}
                        >
                          <h1
                            style={{
                              margin: 0,
                              marginBottom: 10,
                              fontFamily: useResponsiveValue1024("montserrat-Bold","montserrat-SemiBold"),
                              fontSize: useResponsiveValue1024("28px", "22px"),
                            }}
                          >
                            Détails
                          </h1>
                          <Divider></Divider>
                        </div>
                      </Grid>
                      <Grid xs={12} md={4} lg={6} item>
                        <p
                          style={{
                            fontSize: useResponsiveValue1024('16px','14px'),
                            color: "#281208",
                            marginBottom: 8,
                          }}
                          className="para-padd-marg"
                        >
                          Nom d’utilisateur
                        </p>

                        <div
                          style={{
                            height: 56,
                            width: "100%",
                            background: defaultLabelColors.input_feild_bg,
                            borderRadius: 16,
                          }}
                        >
                          <InputField
                            placeHolder={"Prénom"}
                            input_value={state?.user_name}
                            input_name={"first_name"}
                                                        readonly

                            input_style={{
                              background: defaultLabelColors.input_feild_bg,
                              width: "100%",
                              borderRadius: "16px",
                              border: "none",
                              margin: 0,
                              
                            }}
                             customSx={{fontSize:useResponsiveValue1024("16px","14px")}}
                            
                            
                            onchange={onInputChangeTwo}
                          />
                        </div>
                      </Grid>

                      <Grid xs={12} md={4} lg={6} item>
                        <p
                           style={{
                            fontSize: useResponsiveValue1024('16px','14px'),
                            color: "#281208",
                            marginBottom: 8,
                          }}
                          className="para-padd-marg"
                        >
                          Date de naissance{" "}
                        </p>
                        <div
                          style={{
                            height: 56,
                            width: "100%",
                            background: defaultLabelColors.input_feild_bg,
                            borderRadius: 16,
                            pointerEvents: "none",
                          }}
                        >
                          <CustomDatePicker
                            onChange={handleDateChange}
                            value={selectedDate}
                            disableFuture={true}
                            fontFamily="montserrat-Regular"
                            placeholder={strings?.date_of_birth_placeholder}
                            backgroundColor={defaultLabelColors.input_feild_bg}
                          />
                        </div>
                      </Grid>
                      <Grid xs={12} md={4} lg={6} item>
                        <p
                           style={{
                            fontSize: useResponsiveValue1024('16px','14px'),
                            color: "#281208",
                            marginBottom: 8,
                          }}
                          className="para-padd-marg"
                        >
                          Prénom{" "}
                        </p>
                        <div
                          style={{
                            height: 56,
                            width: "100%",
                            background: defaultLabelColors.input_feild_bg,
                            borderRadius: 16,
                          }}
                        >
                          <InputField
                            placeHolder={"Prénom"}
                            input_value={state?.first_name}
                            input_name={"first_name"}
                                                        readonly

                            input_style={{
                              background: defaultLabelColors.input_feild_bg,
                              width: "100%",
                              borderRadius: "16px",
                              border: "none",
                              margin: 0,
                            }}
                            onchange={onInputChangeTwo}
                          />
                        </div>
                      </Grid>
                      <Grid xs={12} md={4} lg={6} item>
                        <p
                           style={{
                            fontSize: useResponsiveValue1024('16px','14px'),
                            color: "#281208",
                            marginBottom: 8,
                          }}
                          className="para-padd-marg"
                        >
                          Nom{" "}
                        </p>
                        <div
                          style={{
                            height: 56,
                            width: "100%",
                            background: defaultLabelColors.input_feild_bg,
                            borderRadius: 16,
                          }}
                        >
                          <InputField
                            placeHolder={"Nom"}
                            input_value={state?.surname}
                            input_name={"surname"}
                                                        readonly

                            input_style={{
                              background: defaultLabelColors.input_feild_bg,
                              width: "100%",
                              borderRadius: "16px",
                              border: "none",
                              margin: 0,
                            }}
                            onchange={onInputChangeTwo}
                          />
                        </div>
                      </Grid>
                      <Grid xs={12} md={4} lg={6} item>
                        <p
                           style={{
                            fontSize: useResponsiveValue1024('16px','14px'),
                            color: "#281208",
                            marginBottom: 8,
                          }}
                          className="para-padd-marg"
                        >
                          Email{" "}
                        </p>
                        <div
                          style={{
                            height: 56,
                            width: "100%",
                            background: defaultLabelColors.input_feild_bg,
                            borderRadius: 16,
                          }}
                        >
                          <InputField
                            placeHolder={"Prénom"}
                            input_value={state?.email}
                            input_name={"email"}
                            readonly
                            input_style={{
                              background: defaultLabelColors.input_feild_bg,
                              width: "100%",
                              borderRadius: "16px",
                              border: "none",
                              margin: 0,
                            }}
                            onchange={onInputChangeTwo}
                          />
                        </div>
                      </Grid>
                      <Grid xs={12} md={4} lg={6} item>
                        <p
                           style={{
                            fontSize: useResponsiveValue1024('16px','14px'),
                            color: "#281208",
                            marginBottom: 8,
                          }}
                          className="para-padd-marg"
                        >
                          Télphone{" "}
                        </p>
                        <div
                          style={{
                            height: 56,
                            width: "100%",
                            background: defaultLabelColors.input_feild_bg,
                            borderRadius: 16,
                          }}
                        >
                          <InputField
                            placeHolder={"Télphone"}
                            input_value={`${state?.phone_code} ${state?.phone}`}
                            input_name={"Télphone"}
                            readonly
                            input_style={{
                              background: defaultLabelColors.input_feild_bg,
                              width: "100%",
                              borderRadius: "16px",
                              border: "none",
                              margin: 0,
                            }}
                            onchange={onInputChangeTwo}
                          />
                        </div>
                      </Grid>
                    </Grid>

                    <Divider sx={{ marginTop: 2 }}></Divider>

                    <div
                      style={{
                        background: color_theme.white,

                        padding: useResponsiveValue1024("16px 16px", "16px 0px"),
                      }}
                    >
                      {state?.userDetails?.idenfy_verification === true &&
                      state?.userDetails?.idenfy_verification_status ===
                        "APPROVED" ? (
                        <div style={{ display: "flex", gap: 20 }}>
                          <div
                            style={{
                              flex: 1,
                              fontFamily: "montserrat-Bold",
                              color: "#000",
                              fontSize: "20px",
                            }}
                          >
                            {selector?.mainApp?.lang === "fr"
                              ? "Vérification d'identité"
                              : "ID Verification"}
                            <p
                              style={{
                                fontFamily: "montserrat-Medium",

                                fontSize: "18px",
                                fontWeight: "500",
                              }}
                            >
                              {selector?.mainApp?.lang === "fr"
                                ? "Votre statut de vérification est approuvé"
                                : "Your Verification Status is Approved"}
                            </p>
                          </div>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "flex-end",
                            }}
                          >
                          </div>
                        </div>
                      ) : state?.userDetails?.idenfy_verification === false &&
                        state?.userDetails?.idenfy_verification_status ===
                          "DENIED" ? (
                        <>
                          <div style={{ display: "flex", gap: 20 }}>
                            <div
                              style={{
                                flex: 1,
                                fontFamily:"montserrat-Bold",
                                color: "#000",
                                fontSize: "32px",
                                display: "flex",
                                alignItems: "center",
                              }}
                            >
                              ID Verification
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "flex-end",
                                  paddingLeft: "20px",
                                }}
                              >
                                <IdenfyDeniedIcon />
                              </div>
                            </div>
                          </div>
                          <div
                            style={{
                              fontFamily:"montserrat-Regular",
                              fontSize: "18px",
                              fontWeight: "500",
                              marginTop: "10px",
                            }}
                          >
                            Your Verification Status is Denied
                          </div>
                          <p>
                            <CustomButton
                              style={{
                                fontSize: "16px",
                                fontWeight: "500",
                                color: "#fff",
                                fontFamily:"montserrat-Bold",

                                background: "#ee6931",
                                border: "none",
                                borderRadius: "12px",
                                padding: "10px 40px 10px 40px",
                              }}
                              value={"Start verification"}
                              onClick={handleStartVerification}
                            />
                          </p>
                        </>
                      ) : state?.userDetails?.idenfy_verification === false &&
                        state?.userDetails?.idenfy_verification_status ===
                          "SUSPECTED" ? (
                        <>
                          <div style={{ display: "flex", gap: 20 }}>
                            <div
                              style={{
                                flex: 1,
                                fontFamily:"montserrat-Bold",

                                color: "#000",
                                fontSize: "32px",
                                display: "flex",
                                alignItems: "center",
                              }}
                            >
                              ID Verification
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "flex-end",
                                  paddingLeft: "20px",
                                }}
                              >
                                <IdenfySuspectedIcon />
                              </div>
                            </div>
                          </div>
                          <div
                            style={{
                              fontFamily:"montserrat-Medium",

                              fontSize: "18px",
                              fontWeight: "500",
                              marginTop: "10px",
                            }}
                          >
                            Your Verification Status is Suspected
                          </div>
                          <p>
                            <CustomButton
                              style={{
                                fontSize: "16px",
                                fontWeight: "500",
                                color: "#fff",
                                fontFamily:"montserrat-Bold",

                                background: "#ee6931",
                                border: "none",
                                borderRadius: "12px",
                                padding: "10px 40px 10px 40px",
                                marginLeft: "10px",
                              }}
                              value={"Start Verification"}
                              onClick={handleStartVerification}
                            />
                          </p>
                        </>
                      ) : state?.userDetails?.idenfy_verification === false &&
                        state?.userDetails?.idenfy_verification_status ===
                          "REVIEWING" ? (
                        <>
                          <div style={{ display: "flex", gap: 20 }}>
                            <div
                              style={{
                                flex: 1,
                                fontFamily:"montserrat-Bold",

                                color: "#000",
                                fontSize: "32px",
                                display: "flex",
                                alignItems: "center",
                              }}
                            >
                              ID Verification
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "flex-end",
                                  paddingLeft: "20px",
                                }}
                              >
                                <IdenfyReviewingIcon />
                              </div>
                            </div>
                          </div>
                          <div
                            style={{
                              fontFamily:"montserrat-Medium",

                              fontSize: "18px",
                              fontWeight: "500",
                              marginTop: "10px",
                            }}
                          >
                            Your Verification Status is Reviewing
                          </div>
                          <p>
                            <CustomButton
                              style={{
                                fontSize: "16px",
                                fontWeight: "500",
                                color: "#fff",
                                fontFamily:"montserrat-Bold",

                                background: "#ee6931",
                                border: "none",
                                borderRadius: "12px",
                                padding: "10px 40px 10px 40px",
                                marginLeft: "10px",
                              }}
                              value={"Start Verification"}
                              onClick={handleStartVerification}
                            />
                          </p>
                        </>
                      ) : state?.userDetails?.idenfy_verification === false &&
                        state?.userDetails?.idenfy_verification_status ===
                          "DELETED" ? (
                        <>
                          <div style={{ display: "flex", gap: 20 }}>
                            <div
                              style={{
                                flex: 1,
                                fontFamily:"montserrat-Bold",

                                color: "#000",
                                fontSize: "32px",
                                display: "flex",
                                alignItems: "center",
                              }}
                            >
                              ID Verification
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "flex-end",
                                  paddingLeft: "20px",
                                }}
                              >
                                <IdenfyDeletedIcon />
                              </div>
                            </div>
                          </div>
                          <div
                            style={{
                              fontFamily:"montserrat-Medium",

                              fontSize: "18px",
                              fontWeight: "500",
                              marginTop: "10px",
                            }}
                          >
                            Your Verification Status is Deleted
                          </div>
                          <p>
                            <CustomButton
                              style={{
                                fontSize: "16px",
                                fontWeight: "500",
                                color: "#fff",
                                fontFamily:"montserrat-Bold",

                                background: "#ee6931",
                                border: "none",
                                borderRadius: "12px",
                                padding: "10px 40px 10px 40px",
                                marginLeft: "10px",
                              }}
                              value={"Start Verification"}
                              onClick={handleStartVerification}
                            />
                          </p>
                        </>
                      ) : state?.userDetails?.idenfy_verification === false &&
                        state?.userDetails?.idenfy_verification_status ===
                          "ARCHIVED" ? (
                        <>
                          <div style={{ display: "flex", gap: 20 }}>
                            <div
                              style={{
                                flex: 1,
                                fontFamily:"montserrat-Bold",

                                color: "#000",
                                fontSize: "32px",
                                display: "flex",
                                alignItems: "center",
                              }}
                            >
                              ID Verification
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "flex-end",
                                  paddingLeft: "20px",
                                }}
                              >
                                <IdenfyArchivedIcon />
                              </div>
                            </div>
                          </div>
                          <div
                            style={{
                              fontFamily:"montserrat-Medium",

                              fontSize: "18px",
                              fontWeight: "500",
                              marginTop: "10px",
                            }}
                          >
                            Your Verification Status is Archived
                          </div>
                          <p>
                            <CustomButton
                              style={{
                                fontSize: "16px",
                                fontWeight: "500",
                                color: "#fff",
                                fontFamily:"montserrat-Bold",

                                background: "#ee6931",
                                border: "none",
                                borderRadius: "12px",
                                padding: "10px 40px 10px 40px",
                                marginLeft: "10px",
                              }}
                              value={"Start Verification"}
                              onClick={handleStartVerification}
                            />
                          </p>
                        </>
                      ) : state?.userDetails?.idenfy_verification === false &&
                        state?.userDetails?.idenfy_verification_status ===
                          "EXPIRED" ? (
                        <>
                          <div style={{ display: "flex", gap: 20 }}>
                            <div
                              style={{
                                flex: 1,
                                fontFamily:"montserrat-Bold",

                                color: "#000",
                                fontSize: "32px",
                                display: "flex",
                                alignItems: "center",
                              }}
                            >
                              ID Verification
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "flex-end",
                                  paddingLeft: "20px",
                                }}
                              >
                                <IdenfyExpiredIcon />
                              </div>
                            </div>
                          </div>
                          <div
                            style={{
                              fontFamily:"montserrat-Medium",

                              fontSize: "18px",
                              fontWeight: "500",
                              marginTop: "10px",
                            }}
                          >
                            Your Verification Status is Expired
                          </div>
                          <p>
                            <CustomButton
                              style={{
                                fontSize: "16px",
                                fontWeight: "500",
                                color: "#fff",
                                fontFamily:"montserrat-Bold",
                                background: "#ee6931",
                                border: "none",
                                borderRadius: "12px",
                                padding: "10px 40px 10px 40px",
                                marginLeft: "10px",
                              }}
                              value={"Start Verification"}
                              onClick={handleStartVerification}
                            />
                          </p>
                        </>
                      ) : state?.userDetails?.idenfy_verification === false &&
                        state?.userDetails?.idenfy_verification_status ===
                          "ACTIVE" ? (
                        <>
                          <div style={{ display: "flex", gap: 20 }}>
                            <div
                              style={{
                                flex: 1,
                                fontFamily:"montserrat-Bold",

                                color: "#000",
                                fontSize: "32px",
                                display: "flex",
                                alignItems: "center",
                              }}
                            >
                              ID Verification
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "flex-end",
                                  paddingLeft: "20px",
                                }}
                              >
                              </div>
                            </div>
                          </div>
                          <div
                            style={{
                              fontFamily:"montserrat-Medium",
                              fontSize: "18px",
                              fontWeight: "500",
                              marginTop: "10px",
                            }}
                          >
                            Your Verification Status is Active
                          </div>
                        </>
                      ) : (
                        <Grid container spacing={2}>
                          <Grid xs={12} item>
                            <h2
                              className="profile-headings"
                              style={{ fontSize: 20 }}
                            >
                              Vérification d'identité
                            </h2>
                          </Grid>

                          <Grid xs={12} item>
                            <p className="profile-text">
                              Pour garantir des validations rapides des
                              documents, envoyez des photos ou des scans
                            </p>
                            <div>
                              <p className="profile-text">
                                {" "}
                                1. En couleur : Les documents en noir et blanc
                                ne seront pas acceptés.
                              </p>
                              <p className="profile-text">
                                2. Complet : Assurez-vous qu’aucune information
                                ne soit masquée
                              </p>
                              <p className="profile-text">
                                3. Lisible et de bonne qualité : Ni flou, ni
                                sombre, ni abîmé et sans reflet.
                              </p>
                            </div>
                          </Grid>
                          <Grid xs={12} item style={{ display: "flex" }}>
                            <CustomButton
                              style={{
                                fontSize: "16px",
                                fontWeight: "500",
                                color: "#fff",
                                fontFamily:"montserrat-Bold",

                                background: "#ee6931",
                                border: "none",
                                borderRadius: "12px",
                                padding: "10px 40px 10px 40px",
                              }}
                              value={"Commencer la verification"}
                              onClick={handleStartVerification}
                            />
                          </Grid>
                        </Grid>
                      )}
                    </div>
                    <Divider></Divider>
                    <div
                      style={{
                        background: color_theme.white,
                        padding: useResponsiveValue1024("16px 16px", "16px 0px"),
                      }}
                    >
                      <div>
                        <h2
                          style={{
                            fontSize: 20,
                            color: "#000000",
                            fontFamily:"montserrat-SemiBold",
                            

                          }}
                        >
                          Modifier le mot de passe
                        </h2>
                        <p
                          style={{
                            fontSize: 16,
                            color: "#000000",
                            fontFamily:"montserrat-Medium",

                          }}
                        >
                          Pour modifier votre mot de passe, veuillez saisir
                          votre mot de passe actuel pour confirmer votre
                          identité.
                        </p>
                      </div>

                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: 15,
                        }}
                      >
                        <div
                          style={{
                            minWidth: 270,
                            maxWidth: useResponsiveValue1024("386px", "100%"),
                          }}
                        >
                          <p
                            style={{
                              fontSize: 16,
                              color: "#281208",
                              marginBottom: 10,

                            }}
                            className="para-padd-marg"
                          >
                            Mot de passe actuel{" "}
                          </p>
                          <div
                            style={{
                              height: 56,
                              width: "100%",
                              background: defaultLabelColors.input_feild_bg,
                              borderRadius: 16,
                            }}
                          >
                            <InputField
                              placeHolder={""}
                              input_value={state?.oldPassword}
                              input_name={"oldPassword"}
                              // readonly
                              input_style={{
                                background: defaultLabelColors.input_feild_bg,
                                width: "100%",
                                borderRadius: "16px",
                                border: "none",
                                margin: 0,
                              }}
                              onchange={onInputChangeTwo}
                            />
                          </div>
                        </div>

                        <div
                          style={{
                            minWidth: 270,
                            maxWidth: useResponsiveValue1024("386px", "100%"),
                          }}
                        >
                          <CustomButton
                            style={{
                              fontSize: "16px",
                              fontWeight: "500",
                              color: "#fff",
                              fontFamily:"montserrat-Bold",

                              background: "#ee6931",
                              border: "none",
                              borderRadius: "12px",
                              padding: "10px 40px 10px 40px",
                              width: "100%",
                            }}
                            value={"Modifier"}
                            onClick={() => {
                              checkPasswrodValidate();
                            }}
                          />
                        </div>
                      </div>
                    </div>
                    <Divider></Divider>

                    <div
                      id="sectionTwo"
                      style={{
                        background: color_theme.white,
                        padding: useResponsiveValue1024("16px 16px", "16px 0px"),
                      }}
                    >
                      <Grid container spacing={2}>
                        <Grid xs={12} item>
                          <h2
                            style={{
                              fontFamily: "montserrat-Bold",
                              fontWeight: 500,
                              margin: 0,
                              fontSize:"20px",
                            }}
                          >
                            {strings?.payments}
                          </h2>
                        </Grid>
                        <Grid xs={12} item>
                          {console.log(state?.card_detail,"dasd" ) as any
                          }
                          {state?.card_detail?.map((_item: any) => (
                            <div style={{ display: "flex", width: "100%" }}>
                              <div style={{ flex: 1 }}>
                                <div style={{ display: "flex", gap: 10 }}>
                                  <img
                                    src={getCardImage(_item?.card?.brand ?? "")}
                                    style={{ objectFit: "contain", width: 57 }}
                                    alt="not-found"
                                  />
                                  <p className="profile-text" style={{margin:0}}>
                                    {`Carte bancaire  **** ${_item?.card?.last4}`}
                                    <br></br>
                                    <span className="profile-text">{`${_item?.card?.exp_month}/${ (_item?.card?.exp_year % 100).toString().padStart(2, '0') }`}</span>
                                  </p>
                                </div>
                              </div>

                              <div
                                className="display-flex"
                                style={{
                                  gap: 10,
                                  fontFamily:"montserrat-SemiBold",

                                  color: "black",
                                }}
                              >
                                <p
                                  className="profile-text"
                                  style={{
                                    fontFamily:"montserrat-Bold",

                                    color: "#FF3B30",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => {
                                    setState({
                                      openConfirmDialog: true,
                                      card_id: _item?.id,
                                    });
                                  }}
                                >
                                  {"Supprimer"}
                                </p>{" "}
                              </div>
                            </div>
                          ))}
                        </Grid>

                        <Grid xs={12} item>
                          <div
                            style={{
                              minWidth: 270,
                              maxWidth: useResponsiveValue1024("386px", "100%"),
                            }}
                          >
                            <CustomButton
                              style={{
                                fontSize: "16px",
                                fontWeight: "500",
                                color: "#fff",
                                fontFamily:"montserrat-Bold",

                                background: "#ee6931",
                                border: "none",
                                borderRadius: "12px",
                                padding: "10px 40px 10px 40px",
                                width: "100%",
                              }}
                              value={"Verifier les moyens de paiements"}
                              // onClick={
                              onClick={handleInitStripeSetupPayment}
                            />
                          </div>
                        </Grid>
                      </Grid>
                    </div>
                    <Divider></Divider>

                    <div
                      id="sectionTwo"
                      style={{
                        background: color_theme.white,
                        padding: 16,
                      }}
                    >
                      <Grid container spacing={2}>
                        <Grid xs={12} item>
                          <h2
                            style={{
                              fontFamily:"montserrat-Bold",
                              fontSize:"20px",

                              fontWeight: 500,
                              margin: 0,
                            }}
                          >
                            {strings?.language}
                          </h2>
                        </Grid>

                        <Grid xs={12} item>
                          <div style={{ display: "flex", width: "100%" }}>
                            <div style={{ flex: 1 }}>
                              <p className="profile-text">Français</p>
                            </div>

                            <div
                              className="display-flex"
                              style={{
                                gap: 10,
                                fontFamily:"montserrat-SemiBold",

                                color: "black",
                              }}
                            >
                              Modifier
                            </div>
                          </div>
                        </Grid>
                      </Grid>
                    </div>
                    <Divider></Divider>
                    <div
                      style={{
                        background: color_theme.white,
                        padding: 16,
                      }}
                    >
                      <Grid container spacing={2}>
                        <Grid xs={12} item>
                          <h2
                            style={{
                              fontFamily:"montserrat-Bold",
                              fontSize:"20px",

                              margin: 0,
                            }}
                          >
                            {"Conditions générales"}
                          </h2>
                        </Grid>

                        <Grid xs={12} item>
                          <div style={{ display: "flex", width: "100%" }}>
                            <div style={{ flex: 1 }}>
                              <p className="profile-text">
                                {"Consulter les conditions générales"}
                              </p>
                            </div>

                            <div
                              className="display-flex"
                              style={{
                                gap: 10,
                                fontFamily:"montserrat-SemiBold",

                                color: "black",
                              }}
                            >
                              <p
                                className="profile-text"
                                style={{
                                  fontFamily:"montserrat-Bold",

                                  color: "black",
                                  cursor: "pointer",
                                }}
                                onClick={() => {
                                  window.open(
                                    "https://www.frank.fr/terms-and-condition"
                                  );
                                }}
                              >
                                {strings?.view}
                              </p>{" "}
                            </div>
                          </div>
                        </Grid>
                      </Grid>
                    </div>
                    <Divider></Divider>
                    <div
                      style={{
                        background: color_theme.white,
                        padding: 16,
                      }}
                    >
                      <Grid container spacing={2}>
                        <Grid xs={12} item>
                          <h2
                            style={{
                              fontFamily: "montserrat-Bold",
                              margin: 0,
                              fontSize:"20px",

                            }}
                          >
                            {"Paramètres de notifications"}
                          </h2>
                        </Grid>

                        <Grid xs={12} item>
                          <div style={{ display: "flex", width: "100%" }}>
                            <div style={{ flex: 1 }}>
                              <p className="profile-text">
                                {"Activer les notifications"}
                              </p>
                            </div>

                            <div
                              className="display-flex"
                              style={{
                                gap: 10,
                                fontFamily:"montserrat-SemiBold",

                                color: "black",
                              }}
                            >
                              <SwitchFeild
                                onClick={handleNotificationClick}
                                input_label=""
                              />
                            </div>
                          </div>
                        </Grid>
                      </Grid>
                    </div>
                    <Divider></Divider>
                    <div
                      style={{
                        background: color_theme.white,
                        padding: 16,
                      }}
                    >
                      <div 
                      style={{
                        display:"flex",
                        justifyContent:useResponsiveValue1024("","center")
                      }}
                      >
                        <p
                          className="profile-text"
                          style={{
                            fontFamily:"montserrat-SemiBold",

                            color: "#FF0000",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            navigate("/delete-account");
                          }}
                        >
                          {"Supprimer le compte"}
                        </p>
                      </div>
                    </div>
                  </CustomTabPanel>

                  <CustomTabPanel value={value} index={1}>
                    <div
                      style={{
                        height: "100vh",
                      }}
                    >
                      <Grid
                        xs={12}
                        lg={12}
                        item
                        container
                        spacing={2}
                        key={"text-area"}
                      >
                        <Grid xs={12} md={12} item>
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                            }}
                          >
                            <h1 style={{ margin: 0, marginBottom: 10,fontSize:useResponsiveValue1024("28px","22px"),fontFamily:"montserrat-Bold" }}>
                              Évaluations
                            </h1>
                          </div>
                        </Grid>
                        <Grid xs={12} md={12} item>
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                            }}
                          >
                            <h2 style={{ margin: 0, marginBottom: 10,fontSize:useResponsiveValue1024("20px","18px"),fontFamily:"montserrat-Bold" }}>
                              {`Commentaires des utilisateurs sur ${
                                state?.userDetails?.first_name ?? ""
                              }`}
                            </h2>
                            <Divider></Divider>
                            {reviews && reviews.length > 0 ? (
                              <div
                                style={{
                                  width: "100%",
                       
                                  padding: "20px",
                                }}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "flex-end",
                                    marginBottom: "20px",
                                  }}
                                >
                                  <IconButton
                                    onClick={handlePrev}
                                    disabled={startIndex === 0}
                                  >
                                    <svg
                                      width="32"
                                      height="32"
                                      viewBox="0 0 32 32"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <rect
                                        x="31.5"
                                        y="31.5"
                                        width="31"
                                        height="31"
                                        rx="15.5"
                                        transform="rotate(180 31.5 31.5)"
                                        fill="white"
                                      />
                                      <rect
                                        x="31.5"
                                        y="31.5"
                                        width="31"
                                        height="31"
                                        rx="15.5"
                                        transform="rotate(180 31.5 31.5)"
                                        stroke="#E0E0E0"
                                      />
                                      <path
                                        d="M19 10L13 16L19 22"
                                        stroke={
                                          startIndex === 0
                                            ? "#E9E8EB"
                                            : "#4B4A61"
                                        }
                                        stroke-width="2"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                      />
                                    </svg>
                                  </IconButton>

                                  <IconButton
                                    onClick={handleNext}
                                    disabled={
                                      startIndex + itemsPerPage >=
                                      reviews?.length
                                    }
                                  >
                                    <svg
                                      width="32"
                                      height="32"
                                      viewBox="0 0 32 32"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <rect
                                        x="0.5"
                                        y="0.5"
                                        width="31"
                                        height="31"
                                        rx="15.5"
                                        fill="white"
                                      />
                                      <rect
                                        x="0.5"
                                        y="0.5"
                                        width="31"
                                        height="31"
                                        rx="15.5"
                                        stroke="#E0E0E0"
                                      />
                                      <path
                                        d="M13 22L19 16L13 10"
                                        stroke={
                                          startIndex + itemsPerPage >=
                                          reviews?.length
                                            ? "#E9E8EB"
                                            : "#4B4A61"
                                        }
                                        stroke-width="2"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                      />
                                    </svg>
                                  </IconButton>
                                </div>
                                <div
                                  style={{
                                    display: "flex",
                                    gap: "16px",
                                  }}
                                >
                                  {reviews
                                    ?.slice(
                                      startIndex,
                                      startIndex + itemsPerPage
                                    )
                                    .map((review: any, index: number) => (
                                      <div
                                        style={{
                                          padding: "16px",
                                          borderColor: "#E0E0E0",
                                          border: "1px solid #E0E0E0",
                                          borderRadius: "24px",
                                   
                                          width: 380,
                                          height:"max-content"
                                        }}
                                      >
                                        <div>
                                          <Rating
                                            size={15}
                                            initialValue={review?.rating}

                                            fillIcon={<SmallStarIcon />}
                                            emptyIcon={<SmallStarIconGray />}
                                            readonly
                                            allowFraction
                                          />

                                          <Typography
                                            variant="body2"
                                            style={{ marginTop: "8px",color:"#080626",fontFamily:"montserrat-Medium",fontSize:"16px" }}
                                          >
                                            {review.feedback}
                                          </Typography>

                                          <div
                                            id="yy"
                                            style={{
                                              display: "flex",
                                              gap: 10,
                                              padding: 5,
                                            }}
                                          >
                                            <div>
                                              <Avatar
                                                alt="Remy Sharp"
                                                src={
                                                  review?.profile_pic ??
                                                  no_profile_image
                                                }

                                              />
                                            </div>
                                            <div>
                                              <Typography
                                                variant="h6"
                                                color={"#BCBBC4"}
                                                sx={{
                                                  margin: 0,
                                                  lineHeight: 1.4,
                                                  fontSize: 16,
                                                  fontFamily:"montserrat-Medium",
                                                }}
                                              >
                                                {review?.added_by}
                                              </Typography>
                                              <Typography
                                                variant="subtitle2"
                                                color={"#BCBBC4"}
                                                style={{
                                                  fontFamily:"montserrat-Medium",
fontSize:"16px"
                                                }}
                                              >
                                                {moment(
                                                  review?.created_at
                                                ).format("MMMM YYYY")}
                                              </Typography>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    ))}
                                </div>
                              </div>
                            ) : (
                              <h2 style={{ margin: 0, marginBottom: 10 ,fontSize:20,fontFamily:"montserrat-Bold"}}>
                                {`Aucune évaluations n’as été rédigé pour ${
                                  state?.userDetails?.first_name ?? ""
                                }`}
                              </h2>
                            )}
                          </div>
                        </Grid>
                      </Grid>
                    </div>
                  </CustomTabPanel>
                </div>
              </div>
            </Grid>
          </Grid>
        </div>
        </div>
        </div>
        <DraggableDialog
          maxWidth={"sm"}
          open={state?.pass_dialog}
          handleClose={() => {
            setState({
              pass_dialog: false,
              oldPassword: "",
              newPassword: "",
              confirmPassword: "",
            });
          }}
          dialog_title={"Modifier le mot de passe"}
          classes={classes}
          dialogBody={
            <DialogContent
              style={{
                display: "flex",
                background: "#FFF",
                justifyContent: "center",
              }}
            >
              <Grid container spacing={2}>
                <Grid xs={12} item>
                  <p
                    style={{
                      fontSize: screen_1024 ? 16 :18,
                      color: "#281208",
                      marginBottom: 10,
                    }}
                    className="para-padd-marg"
                  >
                    Nouveau mot de passe{" "}
                  </p>

                  <div
                    style={{
                      height: 56,
                      width: "100%",
                      background: defaultLabelColors.input_feild_bg,
                      borderRadius: 16,
                    }}
                  >
                    <InputField
                      input_type={
                        state?.viewPasswordOld === false ? "password" : "text"
                      }
                      onchange={onInputChangeTwo}
                      startIcon={<LockOpen />}
                      placeHolder={strings?.password}
                      input_value={state?.newPassword}
                      input_name={"newPassword"}
                      input_style={{
                        background: defaultLabelColors.input_feild_bg,
                        width: "100%",
                        borderRadius: "16px",
                        border: "none",
                        margin: 0,
                      }}
                      endIicon={
                        state?.viewPasswordOld ? (
                          <Visibility
                            onClick={() => {
                              setState({
                                viewPasswordOld: !state?.viewPasswordOld,
                              });
                            }}
                            style={{ color: "gray", cursor: "pointer" }}
                          />
                        ) : (
                          <VisibilityOff
                            onClick={() => {
                              setState({
                                viewPasswordOld: !state?.viewPasswordOld,
                              });
                            }}
                            style={{ color: "gray", cursor: "pointer" }}
                          />
                        )
                      }
                    />
                  </div>
                </Grid>

                <Grid xs={12} item>
                  <p
                    style={{
                      fontSize: screen_1024 ? 16 :18,

                      color: "#281208",
                      marginBottom: 10,
                    }}
                    className="para-padd-marg"
                  >
                    Confirmez votre nouveau mot de passe{" "}
                  </p>

                  <div
                    style={{
                      height: 56,
                      width: "100%",
                      background: defaultLabelColors.input_feild_bg,
                      borderRadius: 16,
                    }}
                  >
                    {" "}
                    <InputField
                      input_type={
                        state?.viewPasswordNew === false ? "password" : "text"
                      }
                      onchange={onInputChangeTwo}
                      startIcon={<LockOpen />}
                      placeHolder={strings?.set_new_password}
                      input_value={state?.confirmPassword}
                      input_name={"confirmPassword"}
                      input_style={{
                        background: defaultLabelColors.input_feild_bg,
                        width: "100%",
                        borderRadius: "16px",
                        border: "none",
                        margin: 0,
                      }}
                      endIicon={
                        state?.viewPasswordNew ? (
                          <Visibility
                            onClick={() => {
                              setState({
                                viewPasswordNew: !state?.viewPasswordNew,
                              });
                            }}
                            style={{ color: "gray", cursor: "pointer" }}
                          />
                        ) : (
                          <VisibilityOff
                            onClick={() => {
                              setState({
                                viewPasswordNew: !state?.viewPasswordNew,
                              });
                            }}
                            style={{ color: "gray", cursor: "pointer" }}
                          />
                        )
                      }
                    />
                  </div>
                </Grid>

                <Grid xs={12} item>
                  <CustomButton
                    style={{
                      fontSize: "16px",
                      fontWeight: "500",
                      color: "#fff",
                      fontFamily:"montserrat-Bold",

                      background: "#ee6931",
                      border: "none",
                      borderRadius: "12px",
                      padding: "10px 40px 10px 40px",
                      width: "100%",
                    }}
                    value={"Modifier mon mot de passe"}
                    onClick={handleChangePassword}
                  />
                </Grid>
              </Grid>
            </DialogContent>
          }
        />
        <DraggableDialog
          maxWidth={"md"}
          Width={600}
          open={state?.openIdenfyDialog}
          handleClose={() => {
            setState({
              openIdenfyDialog: false,
            });
            handleGetProfileInfo();
          }}
          classes={classes}
          dialogBody={
            idenfyToken && (
              <iframe
                title="iframe"
                id="iframe"
                allowFullScreen={true}
                style={{
                  width: "100%",
                  height: 700,
                  border: "none",
                  outline: "none",
                }}
                src={`https://ui.idenfy.com/?authToken=${idenfyToken}&lang=fr`}
                allow="camera"
              />
            )
          }
        />

        <DraggableDialog
          maxWidth={"md"}
          Width={600}
          open={state?.openFuturePayment}
          handleClose={() => {
            setState({ openFuturePayment: false });
          }}
          dialog_title={"Méthode de paiement"}
          classes={classes}
          dialogBody={
            <DialogContent
              style={{
                display: "flex",
                justifyContent: "center",
              }}
              dividers
            >
              <Grid
                container
                spacing={2}
                style={{ display: "flex", flexDirection: "column",padding:'0px 12px' }}
              >
                {state.stripe_type === "order_payment" ? (
                  state.stripe_form?.paymentIntent && (
                    <Elements
                      stripe={stripePromise}
                      options={{
                        clientSecret: state.stripe_form?.paymentIntent,
                        appearance: {
                          theme: "stripe",
                          variables: {
                            fontFamily:"montserrat-Medium",

                          },
                          rules: {
                            ".Label": {
                              fontFamily:"montserrat-Medium",

                              fontSize: "14px", // Adjust the size as needed
                              color: "#000000", // Change the color if needed
                            },
                          },
                        },
                      }}
                    >
                      <InjectedCheckoutForm
                        handleConfirmPayment={handleConfirmPayment}
                        onPressBuy={() =>
                          setState({
                            loading: true,
                          })
                        }
                      />
                    </Elements>
                  )
                ) : (
                  <Elements
                    stripe={stripePromise}
                    options={{
                      clientSecret: state.options?.setupIntent,
                      customerSessionClientSecret: state.options?.customer,
                      customerOptions: {
                        customer: state.options?.customer,
                        ephemeralKey: state.options?.ephemeralKey,
                      },
                   
                    }}
                  >
                    <StripeCheckout
                      handleCloseDialog={handleCloseDialog}
                      handleGetCardDetails={getCardDetails}
                    />
                  </Elements>
                )}
              </Grid>
            </DialogContent>
          }
        />

        <DraggableDialog
          maxWidth={"md"}
          Width={600}
          open={state?.openForm}
          handleClose={() => {
            setState({ openForm: false });
          }}
          dialog_title={"Enter Bank Details"}
          classes={classes}
          dialogBody={
            <DialogContent
              style={{
                display: "flex",
                background: "#fff",
                justifyContent: "center",
                padding: "10px 60px",
              }}
              dividers
            >
              <Grid
                container
                spacing={2}
                style={{ display: "flex", flexDirection: "column" }}
              >
                <BankUpdateForm onSubmit={handleSubmit} />
              </Grid>
            </DialogContent>
          }
        />
        <DraggableDialog
          maxWidth={"sm"}
          open={state?.openConfirmDialog}
          handleClose={() => {
            setState({ openConfirmDialog: false, card_id: null });
          }}
          dialog_title={"Confirmation"}
          classes={classes}
          dialogBody={
            <DialogContent style={{}} dividers>
              <div>
                <p
                  style={{
                    fontFamily:"montserrat-SemiBold",

                    fontSize: "26px",
                    fontWeight: "600",
                  }}
                >
                  Voulez-vous supprimer votre carte ?
                </p>
              </div>
            </DialogContent>
          }
          dialogFooter={
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "flex-end",
                gap: 10,
                padding: 10,
              }}
            >
              <CustomButton
                value={"Oui"}
                style={{
                  fontSize: "16px",
                  fontWeight: "500",
                  color: "#fff",
                  fontFamily:"montserrat-Bold",

                  background: "#ee6931",
                  border: "none",
                  borderRadius: "12px",
                  padding: "10px 40px 10px 40px",
                  marginTop: "10px",
                }}
                onClick={() => deleteCard(state?.card_id)}
              />
              <CustomButton
                value={"Non"}
                style={{
                  fontSize: "16px",
                  fontWeight: "500",
                  color: "#ee6931",
                  border: "1px solid #ee6931",
                  fontFamily:"montserrat-Bold",

                  background: "#fff",
                  borderRadius: "12px",
                  padding: "10px 40px 10px 40px",
                  marginTop: "10px",
                }}
                onClick={() => {
                  setState({ openConfirmDialog: false, card_id: null });
                }}
              />
            </div>
          }
        />
      </div>

      <div className="mobile-screen" style={{ width: "100%" }}>
        <ProfileMobileView />
      </div>
    </>
  );
}

export default Profile;
